/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SummarizeToolCallRequestBody,
  SummarizeToolCallRequestBody$Outbound,
  SummarizeToolCallRequestBody$outboundSchema,
} from "../components/summarizetoolcallrequestbody.js";

export type SummarizeToolCallSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type SummarizeToolCallRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  summarizeToolCallRequestBody: SummarizeToolCallRequestBody;
};

/** @internal */
export type SummarizeToolCallSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SummarizeToolCallSecurity$outboundSchema: z.ZodMiniType<
  SummarizeToolCallSecurity$Outbound,
  SummarizeToolCallSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function summarizeToolCallSecurityToJSON(
  summarizeToolCallSecurity: SummarizeToolCallSecurity,
): string {
  return JSON.stringify(
    SummarizeToolCallSecurity$outboundSchema.parse(summarizeToolCallSecurity),
  );
}

/** @internal */
export type SummarizeToolCallRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SummarizeToolCallRequestBody: SummarizeToolCallRequestBody$Outbound;
};

/** @internal */
export const SummarizeToolCallRequest$outboundSchema: z.ZodMiniType<
  SummarizeToolCallRequest$Outbound,
  SummarizeToolCallRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    summarizeToolCallRequestBody: SummarizeToolCallRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      summarizeToolCallRequestBody: "SummarizeToolCallRequestBody",
    });
  }),
);

export function summarizeToolCallRequestToJSON(
  summarizeToolCallRequest: SummarizeToolCallRequest,
): string {
  return JSON.stringify(
    SummarizeToolCallRequest$outboundSchema.parse(summarizeToolCallRequest),
  );
}
